import React from 'react';
import Modal from 'react-modal';
import _ from 'lodash';
import '../css/SystemIntegratorEdit.css';
import ErrorText from '../ErrorText';
import Loader from './Loader';
import SnackBar from './SnackBar';
import { InputLabel, MenuItem, TextField, Select, FormControl } from '@mui/material';

//Distributor edit page  component
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
        // background: 'none !important'
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};


const customStylesSuccess = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '70%',
        overflow: 'auto',
        padding: '2%',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};

export default class UserEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: this.props.activeModal,
            modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
            noOfParams: [],
            fullName: this.props.userCurrentData.name,
            email: this.props.userCurrentData.user_email,
            reportTo: this.props.userCurrentData.role_assigned,
            group: this.props.userCurrentData.role.role_id,
            errorMessage: [],
            modalIsOpenSuccess: false,
            loader: false,
            disableSave: true,
            snackbarActive: false,
            snackbarMessage: '',
            rolesData: [],
            usersList: [],
            userListReversData: [],

        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalSuccess = this.closeModalSuccess.bind(this);

    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }


    closeModalSuccess() {
        this.setState({
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpenSuccess: false,
                    
                }, () => {
                    this.props.closeAllModal()
                })
                     window.location.reload();
            }, 500);

        })
    }
    afterOpenModal() {
    }

    closeModal() {
        this.setState({
            modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpen: false
                }, () => {
                    this.props.closeAllModal()
                })
            }, 500);

        })
    }

    componentDidMount() {
        this.getallrealdata();
    }

    getallrealdata = () => {
        this.setState({ loader: true });

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        };

        // Fetch roles
        const fetchRoles = fetch('/cloud/addRoles/', {
            method: "GET",
            headers: headers
        }).then(res => res.json());

        // Fetch users
        const fetchUsers = fetch('/cloud/addUsers/', {
            method: "GET",
            headers: headers
        }).then(res => res.json());

        // Wait for both to complete
        Promise.all([fetchRoles, fetchUsers])
            .then(([rolesData, userData]) => {
                // console.log(userData);
                this.setState({
                    rolesData,
                    actualdata: rolesData,
                    usersList: userData, // 👈 New state for storing fetched users
                    userListReversData: userData,
                    loader: false
                }, () => {
                });

            })
            .catch(error => {
                this.setState({ loader: false });
            });
    }



    onEditFinal = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }

        let name = this.state.fullName;              // e.g., "Rajat"
        let role = this.state.group;                // e.g., 2
        let user_email = this.state.email;          // e.g., "rajat@rajat.ai"
        let role_assigned = this.state.reportTo; // user email


        fetch(`/cloud/addUsers_detail/${this.props.userCurrentData.id}`, {

            method: "PUT",
            headers: headers,
            body: JSON.stringify({
                name,
                role,
                user_email,
                role_assigned

            })
        })

            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                let rawData = data;
                data = data.data
                // let index = Object.keys(data)[0]
                // let errorLog = index + ": " + data[Object.keys(data)[0]]
                if (rawData !== 'failure') {
                    this.setState({
                        modalIsOpen: false,
                        loader: false
                    }, () => {
                        this.setState({
                            modalIsOpenSuccess: true,
                            
                        })
                   

                    })
                } else {
                    this.setState({
                        loader: false,
                        snackbarActive: true,
                        snackbarMessage: errorLog
                    })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    handleChangeInputBox = (name, event) => {
        this.setState({
            [name]: event,
            disableSave: false,

        });
    };

    onEdit = () => {
        this.setState({
            showErrorMessage: true
        }, () => {
            this.fetchError((e) => {
                if (e === 'NoError') {
                    this.setState({
                        loader: true,
                        disableSave: true
                    }, () => this.onEditFinal())
                }
            })
        })
    }

    fetchError = (noError) => {
        let totalError = 0;

        const { fullName, email, report_to, group } = this.state;

        // if (ErrorText('notEmpty', fullName) !== 'No Error') totalError++;
        // if (ErrorText('email', email) !== 'No Error') totalError++;
        // if (ErrorText('notEmpty', group) !== 'No Error') totalError++;
        // if (ErrorText('notEmpty', report_to) !== 'No Error') totalError++;


        if (totalError === 0) {
            noError('NoError');
        }
    };

    render() {
        // console.log(this.state.group);
        return (
            <React.Fragment>
                {this.state.loader ? <Loader /> : null}
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    className={this.state.modalStateAftereOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModal}>
                            <i class="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>Edit User</h3>
                    <div className="row">
                        <div className="col-6  disableEvent" style={{ pointerEvents: 'none' }}>
                            <TextField
                                required
                                label="User Name"
                                value={this.state.fullName}
                                onChange={(e) => this.handleChangeInputBox('fullName', e.target.value)}
                                // error={ErrorText('notEmpty', this.state.fullName) !== 'No Error' && this.state.showErrorMessage}
                                // helperText={ErrorText('notEmpty', this.state.fullName) !== 'No Error' && this.state.showErrorMessage ? 'Please enter the User Name' : ''}
                                variant="standard"
                                fullWidth
                                sx={{ marginTop: '8%' }}
                                inputProps={{ maxLength: 50 }}
                            />

                        </div>
                        <div className="col-6 ">
                            {/* {this.state.rolesData.length > 0 && ( */}
                            <TextField
                                required
                                sx={{ marginTop: '8%' }}
                                select
                                variant="standard"
                                fullWidth
                                label="Group"
                                value={this.state.group}
                                onChange={(e) => this.setState({ group: e.target.value })}
                            // error={this.state.group === '' && this.state.showErrorMessage}
                            // helperText={
                            //     this.state.group === '' && this.state.showErrorMessage
                            //         ? 'Please select the Group'
                            //         : ''
                            // }
                            >
                                <MenuItem value="" disabled>
                                    Select Group
                                </MenuItem>
                                {this.state.rolesData.map((option) => (
                                    <MenuItem key={option.role_id} value={option.role_id}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                            {/* )} */}



                        </div>

                        <div className="col-6  disableEvent " style={{ pointerEvents: 'none' }}>
                            <TextField
                                required
                                label="User Email"
                                value={this.state.email}
                                onChange={(e) => this.handleChangeInputBox('email', e.target.value)}
                                // error={ErrorText('notEmpty', this.state.fullName) !== 'No Error' && this.state.showErrorMessage}
                                // helperText={ErrorText('notEmpty', this.state.fullName) !== 'No Error' && this.state.showErrorMessage ? 'Please enter the User Name' : ''}
                                variant="standard"
                                fullWidth
                                sx={{ marginTop: '8%' }}
                                inputProps={{ maxLength: 50 }}
                            />
                        </div>


                        <div className="col-6    text-field-modal" style={{ paddingLeft: '9px', paddingRight: '5px', marginTop: '16px' }} >

                            {/* {this.state.usersList.length > 0 && ( */}
                            <FormControl fullWidth variant="standard" sx={{ marginTop: '4.5%' }}>
                                {/* <InputLabel>Report To</InputLabel> */}
                                <InputLabel>
                                    Report To&nbsp;
                                    <span style={{ fontWeight: 'normal', fontSize: '0.9rem', color: '#999' }}>
                                        (Optional)
                                    </span>
                                </InputLabel>

                                <Select
                                    value={this.state.reportTo}
                                    onChange={(e) => {
                                        this.setState({ reportTo: e.target.value, userError: false });
                                    }}
                                >
                                    {this.state.usersList
                                        .filter(user => user.user_email !== this.state.email)
                                        .map((user) => (
                                            <MenuItem key={user.id} value={user.user_email}>
                                                {user.name}
                                            </MenuItem>
                                        ))}
                                </Select>
                                {this.state.userError && <Typography color="error">Please select a user</Typography>}
                            </FormControl>
                            {/* )} */}

                        </div>
                    </div>
                    <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
                        <div className="btn btn-new-grey" onClick={this.closeModal} style={{ marginRight: '15px' }} >Cancel</div>
                        <div className="btn btn-new-green" onClick={() => {
                            // if (!this.state.disableSave) {
                            this.onEdit()
                            // }
                        }
                        }
                        // style={{
                        //     cursor: this.state.disableSave ? 'not-allowed' : '',
                        // }}
                        >Save Changes</div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.modalIsOpenSuccess}
                    style={customStylesSuccess}
                    className={this.state.modalStateAftereOpenSuccess}
                    contentLabel="Example Modal">
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                            <i className="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <div className="display-4 text-center">
                        <h3 className="modal-heading thanks-message">User edited successfully.</h3>
                        <i class="fas fa-check-circle update"></i>
                        <br />
                        <div className="btn btn-new-grey"
                            onClick={this.closeModalSuccess}>
                            Close
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
